/**
 * Analytics Module — Public API
 *
 * Import `tracker` and call typed event methods from any block view.
 * Import `AnalyticsItem` when building the items array for an event.
 *
 * @example
 *   import { tracker } from '../../services/analytics';
 *   tracker.viewItem( currency, [ { item_id: '9', item_name: 'Photo Booth', price: 799, quantity: 1 } ] );
 */

export { tracker } from './tracker';
export type { AnalyticsItem, AnalyticsProvider } from './types';
